export const ops_restapi = {
  "bizdata_ops_restapi": {
    "min_num": 1,
    "max_num": 6,
    "endpoint_url": "",
    "endpoint_headers": {},
    "endpoint_method": "",
    "endpoint_body": {},
    "endpoint_params": {},
    "authentication_type": "",
    "username": "",
    "password": "",
    "refresh_token_url": "",
    "refresh_token_headers": "",
    "refresh_token_method": "",
    "refresh_token_body": "",
    "refresh_token_params": {},
    "pre_request_script": "",
    "response_parameters": "",
    "another_response_parameter": "",
    "key_name_to_update": "",
    "user_key": "",
    "pagination_style": "no_pagination",
    "timer_type": "",
    "interval_in_seconds": 60,
    "schedule": "",
    "target": "bizdata_dataset",
    "user_key_url": ""
  },
  "bizdata_ops_jdbcoutput": {
    "source": "bizdata_dataset",
    "tuple_key": "",
    "batch_size": 1000,
    "jdbc_driver": "",
    "jdbc_string": "",
    "jar_file": "",
    "username": "",
    "password": "",
    "query": "",
    "target": "bizdata_dataset"

  },
  "bizdata_ops_singletomultiline": {
    "source": "bizdata_dataset",
    "chopkey": "",
    "target": "bizdata_dataset"
  },
  "bizdata_ops_eliminate": {
    "source": "bizdata_dataset",
    "eliminate": [],
    "target": "bizdata_dataset"
  },
  "bizdata_ops_rename": {
    "source": "bizdata_dataset",
    "rename": {},
    "target": "bizdata_dataset"
  },
  "bizdata_ops_append": {
    "source": "bizdata_dataset",
    "append": {},
    "target": "bizdata_dataset"
  },
  "bizdata_ops_uppercase": {
    "source": "bizdata_dataset",
    "uppercase": [],
    "target": "bizdata_dataset"
  },
  "bizdata_ops_titlecase": {
    "source": "bizdata_dataset",
    "titlecase": [],
    "target": "bizdata_dataset"
  },
  "bizdata_ops_lowercase": {
    "source": "bizdata_dataset",
    "lowercase": [],
    "target": "bizdata_dataset"
  },
  "bizdata_ops_dropeventsstartswith": {
    "source": "bizdata_dataset",
    "drop_all_event_to_start_with": [],
    "target": "bizdata_dataset"
  },
  "bizdata_ops_dropalleventvalues": {
    "source": "bizdata_dataset",
    "drop_all_event_for_value": [],
    "target": "bizdata_dataset"
  },
  "bizdata_ops_calculater": {
    "source": "bizdata_dataset",
    "calculation_keys": [],
    "new_calculation_keys": [],
    "target": "bizdata_dataset"
  },
  "bizdata_ops_dateanalytics": {
    "source": "bizdata_dataset",
    "date_field_key": [],
    "fiscal_month_start": "",
    "date_column": [],
    "weekday": "",
    "target": "bizdata_dataset"
  },
  "bizdata_ops_substitute": {
    "source": "bizdata_dataset",
    "substitute": [],
    "target": "bizdata_dataset"
  },
  "bizdata_ops_strip": {
    "source": "bizdata_dataset",
    "strip": [],
    "target": "bizdata_dataset"
  },
  "bizdata_ops_substring": {
    "source": "bizdata_dataset",
    "substring": {},
    "target": "bizdata_dataset"
  },
  "bizdata_ops_generatesequence": {
    "source": "bizdata_dataset",
    "sequence_key": "",
    "sequence_number_key": "",
    "target": "bizdata_dataset"
  },
  "bizdata_ops_json2string": {
    "source": "bizdata_dataset",
    "json2string": [],
    "target": "bizdata_dataset"
  },
  "bizdata_ops_string2json": {
    "source": "bizdata_dataset",
    "string2json": [],
    "target": "bizdata_dataset"
  },
  "bizdata_ops_jsontoxml": {
    "source": "bizdata_dataset",
    "key_data": "",
    "response_key": "",
    "target": "bizdata_dataset"
  },
  "bizdata_ops_xmltojson": {
    "source": "bizdata_dataset",
    "get_key": "",
    "response_key": "",
    "target": "bizdata_dataset"
  },
  "bizdata_ops_repeatfirstrow": {
    "source": "bizdata_dataset",
    "source_key": "",
    "fields_to_repeat_value": [],
    "target": "bizdata_dataset"
  },
  "bizdata_ops_toplevel": {
    "source": "bizdata_dataset",
    "column_to_root": [],
    "target": "bizdata_dataset"
  },
  "bizdata_ops_datetimestamp": {
    "source": "bizdata_dataset",
    "date_format": "",
    "datetime_key": "",
    "target": "bizdata_dataset"
  },
  "bizdata_ops_dataaggregation": {
    "source": "bizdata_dataset",
    "agg_data_key": "",
    "groupby_key": "",
    "array_key": "",
    "array_key_nested_columns": [],
    "target": "bizdata_dataset"
  },
  "bizdata_ops_datatypes": {
    "source": "bizdata_dataset",
    "boolean_operator": [],
    "float_operator": [],
    "integer_operator": [],
    "datetime_operator": [],
    "target": "bizdata_dataset"
  },
  "bizdata_ops_round": {
    "source": "bizdata_dataset",
    "round_keys": [],
    "decimal_key_number": 2,
    "target": "bizdata_dataset"
  },
  "bizdata_ops_unpivot": {
    "source": "bizdata_dataset",
    "transpose_key_name": [],
    "transpose_value": [],
    "target": "bizdata_dataset"
  },
  "bizdata_ops_pivot": {
    "source": "bizdata_dataset",
    "get_key": "",
    "transposed_key_name": [],
    "transposed_value": [],
    "target": "bizdata_dataset"
  },
  "bizdata_ops_singleline2tuple": {
    "source": "bizdata_dataset",
    "singleline_key": "",
    "table_headers": [],
    "tuple_key": "",
    "target": "bizdata_dataset"
  },
  "bizdata_ops_tuple2singleline": {
    "source": "bizdata_dataset",
    "tuple_key": "",
    "headers": [],
    "singleline_key": "",
    "target": "bizdata_dataset"
  },
  "bizdata_ops_postgres": {
    "source": "bizdata_dataset",
    "jdbc_driver": "",
    "jdbc_string": "",
    "username": "",
    "password": "",
    "jar_file": "",
    "query": [],
    "target": "bizdata_dataset"
  },
  "bizdata_ops_replacinganyvalue": {
    "source": "bizdata_dataset",
    "substitute": [],
    "target": "bizdata_dataset"
  },
  "bizdata_ops_trim": {
    "source": "bizdata_dataset",
    "trim_keys": [],
    "target": "bizdata_dataset"
  },
  "bizdata_ops_base64decoding": {
    "source": "bizdata_dataset",
    "base64_decode": [],
    "target": "bizdata_dataset"
  },
  "bizdata_ops_base64encoding": {
    "source": "bizdata_dataset",
    "input_type": '',
    "base64_encode": [],
    "target": "bizdata_dataset"
  },
  "bizdata_ops_bodmascal": {
    "source": "bizdata_dataset",
    "calculation_keys": [],
    "new_calculation_keys": [],
    "target": "bizdata_dataset"
  },
  "bizdata_ops_json2dl": {
    "source": "bizdata_dataset",
    "key_data": "",
    "delimiter": "",
    "fields": [],
    "autodetect_column_names": "",
    "skip_header": "",
    "response_key": "",
    "target": "bizdata_dataset"
  },
  "bizdata_ops_dl2json": {
    "source": "bizdata_dataset",
    "key_data": "",
    "delimiter": "",
    "fields": [],
    "autodetect_column_names": "",
    "skip_header": "",
    "response_key": "",
    "target": "bizdata_dataset"
  },
  "bizdata_ops_sleeptime": {
    "source": "bizdata_dataset",
    "sleep_time": 120,
    "target": "bizdata_dataset"
  },
  "bizdata_ops_pycode": {
    "source": "bizdata_dataset",
    "pycode": "",
    "response": "",
    "target": "bizdata_dataset"
  },
  "bizdata_ops_restapitarget": {
    "source": "bizdata_dataset",
    "endpoint_url": "",
    "endpoint_headers": {},
    "endpoint_method": "",
    "endpoint_body": {},
    "endpoint_params": {},
    "authentication_type": "",
    "username": "",
    "password": "",
    "refresh_token_url": "",
    "refresh_token_headers": {},
    "refresh_token_method": "",
    "refresh_token_body": {},
    "refresh_token_params": {},
    "pre_request_script": "",
    "target": "bizdata_dataset"
  },
  "bizdata_ops_email": {
    "source": "bizdata_dataset",
    "From": "",
    "password": "",
    "mailserver": "",
    "port_number": 465,
    "to": [],
    "cc": [],
    "bcc": [],
    "subject": "",
    "source_key": "",
    "body": "",
    "attachment": "",
    "file_name": "",
    "target": "bizdata_dataset"
  },
  "bizdata_ops_analytics": {
    "source": "bizdata_dataset",
    "data_field_key": [],
    "fiscal_month_start": 4,
    "data_column": [],
    "Weekday": "",
    "target": "bizdata_dataset"
  },
  "bizdata_ops_dataextractor": {
    "source": "bizdata_dataset",
    "data_extractor": [
      ""
    ],
    "data_extractor_keys": [],
    "target": "bizdata_dataset"
  },
  "bizdata_ops_file": {
    "source": "bizdata_dataset",
    "target_location": "dummyapi",
    "extension": ".json",
    "write_mode": "a",
    "target": "bizdata_dataset"
  },
  "bizdata_ops_dlakeingestion": {
    "source": "bizdata_dataset",
    "dlake_host": "",
    "dlake_port": 11000,
    "dlusername": "Bizdata360",
    "dlpassword": "4Izvabc",
    "ca_certs_path": "/opt/eZintegrations/lib/datalake_certs/594e68a0bdbe74ba.pem",
    "index_name": "",
    "action_type": "",
    "primary_key": "",
    "refresh_type": "True",
    "request_timeout_sec": 200,
    "indexing_type": "",
    "max_retries": 10,
    "chunk_size": 500,
    "thread_count": 4,
    "queue_size": 4,
    "target": "bizdata_dataset"
  },
  "bizdata_ops_dlsearch": {
    "source": "bizdata_dataset",
    "dlsearch_host": "",
    "dlsearch_port": 11000,
    "dlsearch_username": "",
    "dlsearch_password": "",
    "dlsearch_ca_certs_path": "",
    "dlsearch_index_name": "",
    "dlsearch_scroll": "",
    "dlsearch_timeout": "",
    "dlsearch_batch_size": 1000,
    "dlsearch_body": '',
    "target": "bizdata_dataset"
  },
  "bizdata_ops_filter": {
    "source": "bizdata_dataset",
    "conditional_statement": "",
    "target": "bizdata_dataset"
  },
  "bizdata_ops_encodedecode": {
    "source": "bizdata_dataset",
    "response_key": "",
    "method_type": "",
    "process": "",
    "target": "bizdata_dataset"
  },
  "bizdata_ops_zipfileinbase64": {
    "source": "bizdata_dataset",
    "source_key": "",
    "file_name_key": "",
    "file_extension_key": "",
    "file_data_key": "",
    "base64_response_key": "",
    "target": "bizdata_dataset"
  },
  "bizdata_ops_arraycount": {
    "source": "bizdata_dataset",
    "array_key_name": "",
    "target": "bizdata_dataset"
  },
  "bizdata_ops_dl2array": {
    "source": "bizdata_dataset",
    "dl_key": "",
    "delimiter": "",
    "target": "bizdata_dataset"
  },
  "bizdata_ops_pdfextractor": {
    "source": "bizdata_dataset",
    "file_url": "",
    "base64_key": "",
    "target": "bizdata_dataset"
  },
  "bizdata_ops_fileextractor":{
    "source":"bizdata_dataset",
    "file_data_key":"",
    "target":"bizdata_dataset"
  },
  "bizdata_ops_docunderstanding": {
    "source": "bizdata_dataset",
    "text_key": "",
    "questions": [],
    "output_key": "",
    "target": "bizdata_dataset"
  },
  "bizdata_ops_grokpattern": {
    "source": "bizdata_dataset",
    "input_key": "",
    "grok_pattern": "",
    "target": "bizdata_dataset"
  },
  "bizdata_ops_imgunderstanding": {
    "source": "bizdata_dataset",
    "img_key": "",
    "questions": [],
    "output_key": "",
    "target": "bizdata_dataset"
  },
  "bizdata_ops_filterends": {
    "source": "bizdata_dataset",
    "target": "bizdata_dataset"
  },
  "bizdata_ops_rawsentencegenerator": {
    "source": "bizdata_dataset",
    "singleline_key":"",
    "include_keys": [],
    "raw_response_key": "raw_response",
    "target": "bizdata_dataset"
  },
  "bizdata_ops_timeunits": {
    "source": "bizdata_dataset",
    "timestamp_key": "timestamp",
    "timestamp_column": ["year", "month", "day", "hour", "minute", "second", "microsecond"],
    "target": "bizdata_dataset"
  },
  "bizdata_ops_datachunking": {
    "source": "bizdata_dataset",
    "process_key":[],
    "chunk_key":"",
    "token_size":1000,
    "group_by_chunk":"bizdata_dataset_chunks",
    "target": "bizdata_dataset"
  },
  "bizdata_ops_htmlextractor": {
    "source": "bizdata_dataset",
    "input_html_key": "",
    "output_data_key": "",
    "target": "bizdata_dataset"
  },

  "bizdata_ops_json2avro":{
    "source":"bizdata_dataset",
    "jsondata_key":'',
    "avro_schema":'',
    "response_key":'',
    "target":"bizdata_dataset"
},

"bizdata_ops_avro2json":{
  "source":"bizdata_dataset",
  "avro_data":'',
  "json_data_key":'',
  "target":"bizdata_dataset"
},
"bizdata_ops_extract2array": {
  "source": "bizdata_dataset",
  "list_object_key": "data",
  "extraction_key": ["id", "content"],
  "array_collection_key": ["ids", "documents"],
  "target": "bizdata_dataset"
},
"bizdata_ops_aiops": {
  "source": "bizdata_dataset",
  "question": '',
  "target": "bizdata_dataset"
},

}